module.exports = __webpack_public_path__ + "4a61597b2a896d75c0a4e3ef4c824b3e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-31.png
// module id = 2092
// module chunks = 0